<template>
    <el-dialog title="国际运单" :visible.sync="MarketShow" width="40%" append-to-body>
        <!-- 海逊商场 -->
        <div>
            <el-input v-model="input" style="width: 70%;" placeholder="请输入搜索内容"></el-input>
            <el-button type="primary" class="search" style="margin-left:10px">搜索</el-button>
        </div>
        <div class="margin-top1">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="date" label="商品ID"></el-table-column>
                <el-table-column prop="name" label="图片"></el-table-column>
                <el-table-column prop="address" label="配货简称"></el-table-column>
                <el-table-column prop="date" label="原价"></el-table-column>
                <el-table-column prop="name" label="现价"></el-table-column>
                <el-table-column prop="address" label="重量"></el-table-column>
                <el-table-column prop="address" label="体积"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div style="text-align: center;" @click="matching(scope.row)">匹配</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            style="margin-top: 16px; text-align:right;"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 50, 100, 250]"
            :page-size="pagesize"
            :current-page="currentpage"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        ></el-pagination>
        <!-- 匹配 -->
        <Matching ref="Market"></Matching>
    </el-dialog>
</template>
<script>
import Matching from "./matching.vue";

export default {
    name: "FBMOrder",
    components: {
        Matching
    },
    data() {
        return {
            total: 0,
            MarketShow: false,
            textarea: "",
            currentpage: 1,
            pagesize: 10,
            input: "",
            search: "",
            tableData: [
                {
                    order: "123",
                    img: "../../assets/imags/123.jpg",
                    num: "1",
                    cb: "2"
                }
            ]
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        init() {
            this.MarketShow = true;
        },
        handleSizeChange() {},
        handleCurrentChange() {},
        Marketx() {
            this.$emit("update:MarketShow", false);
        },
        matching() {
            this.$refs.Market.init(); //子级的init
        }
    }
};
</script>
<style lang="scss">
</style>
